import { defineMessages } from 'react-intl'

export default defineMessages({
  button: {
    id: 'logout.banner.button',
    defaultMessage: 'Log out',
  },
  description: {
    id: 'logout.banner.description',
    defaultMessage: 'You’re currently logged in as',
  },
})
